import type { ReactNode } from 'react';

import { Flex } from '@/components/base';
import { Span } from '@/components/Typography/Typo';
import useColor from '@/hooks/domain/useColor';
import { cn } from '@/lib/cn';

type LabelProps = {
  children: ReactNode;
  required?: boolean;
  className?: string;
};

const PropertyNameLabel = (props: LabelProps) => {
  const color = useColor();
  return (
    <Flex a="center" g={4} className={cn('w-[120px]', props.className)}>
      <Span size={2}>{props.children}</Span>
      {props.required && (
        <Span size={2} style={{ color: color.red600 }}>
          *
        </Span>
      )}
    </Flex>
  );
};

export default PropertyNameLabel;
